import React, { Component } from "react";
import { Link } from "react-router-dom";

import { Parallax, ParallaxBanner, ParallaxBannerLayer, ParallaxProvider } from 'react-scroll-parallax';

import RazzoSVG from "../../../assets/images/risottata/Razzo-rosso.svg";
import TikCampus from "../../../assets/images/risottata/Tik-campus.svg";

class Breadcrumb extends Component {
  scrollTop() {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }
  render() {
    return (
      <>
        {/* ===============  breadcrumb area start =============== */}
        <div className="breadcrumb-area">
          <div className="container">
          <ParallaxProvider>
            <Parallax speed={-15}>
              <img src={RazzoSVG} alt="Logo" className="razzo-banner-contact-riso"/>
            </Parallax>
            <Parallax speed={-10}>
              <img src={TikCampus} alt="Tik" className="tik-banner" />
            </Parallax>
            <div className="row align-items-end">
              <div className="col-lg-12">
                <div className="breadcrumb-content">
                  <h2 className="page-title">Kiwanis Club Bellinzona e Valli</h2>
                </div>
              </div>
            </div>
          </ParallaxProvider>
          </div>
        </div>
        {/* ===============  breadcrumb area end =============== */}
      </>
    );
  }
}

export default Breadcrumb;
